var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/return_pickup_logo.c642c24b.png","uri@2x": __webpack_public_path__ + "static/media/return_pickup_logo.1b7fe5b4.png","uri@3x": __webpack_public_path__ + "static/media/return_pickup_logo.e34884b5.png",
    width: 8,
    height: 9
});